(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kv-withdrawal-form"] && !Shopify.designMode) return;
  try {
    (()=>{const f=document.getElementById('withdrawal-form');if(f&&!f.querySelector('.kv-withdrawal-success'))f.addEventListener('submit',()=>{localStorage.setItem('kalandosveny_withdrawal_receipt',JSON.stringify({name:document.getElementById('withdrawal-name')?.value||'',order:document.getElementById('withdrawal-order')?.value||'',email:document.getElementById('withdrawal-email')?.value||'',items:document.getElementById('withdrawal-items')?.value||'',sentAt:new Date().toISOString()}))});if(!document.querySelector('.kv-withdrawal-success'))return;let d={};try{d=JSON.parse(localStorage.getItem('kalandosveny_withdrawal_receipt')||'{}')}catch(e){}const t='ELÁLLÁSI NYILATKOZAT – ÁTVÉTELI ELISMERVÉNY\n\nVállalkozás: Borsos Zsófia EV\nNév: '+(d.name||'')+'\nRendelésazonosító: '+(d.order||'')+'\nVisszaigazolási e-mail: '+(d.email||'')+'\nÉrintett termék(ek) / megjegyzés: '+(d.items||'')+'\nMegküldés napja és időpontja: '+(d.sentAt?new Date(d.sentAt).toLocaleString('hu-HU'):new Date().toLocaleString('hu-HU'))+'\n\nNyilatkozat: Ezúton elállok a fent azonosított szerződéstől.';const r=document.getElementById('withdrawal-receipt');if(r){r.className='kv-receipt';r.textContent=t}document.getElementById('download-withdrawal-receipt')?.addEventListener('click',()=>{const b=new Blob([t],{type:'text/plain;charset=utf-8'}),a=document.createElement('a');a.href=URL.createObjectURL(b);a.download='kalandosveny-elallasi-atveteli-elismerveny.txt';a.click();URL.revokeObjectURL(a.href)})})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
